
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import { configStore } from "@/store/store";
import { PanelPosition, UIPanel } from "@/types/ui";
import { uiWidePanels } from "@/lib/panels/panels";

/**
 * Intended to be used within AppLayout's "body" slot.
 */
@Component
export default class AppLayoutBodyPanelArea extends Vue {
  @Prop()
  position!: PanelPosition;

  @Prop()
  panelState!: UIPanel | "closed";

  get classList() {
    if (this.panelState === "closed") return {};

    const isWide = uiWidePanels.includes(this.panelState);

    return {
      "breakdance-panel": true,
      width288: !isWide,
      width400: isWide,
      "vscroll-wrap": true,
      borderOnLeft: this.position === "right",
      borderOnRight: this.position === "left",
      "breakdance-app-left-area": this.position === "left",
      "breakdance-app-right-area": this.position === "right"
    };
  }

  get builderMode() {
    return configStore.builderMode;
  }
}
